import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

const keycloakProviderInitConfig = {
  onLoad: 'login-required' as const,
};

root.render(
  <React.StrictMode>
    <ReactKeycloakProvider 
      authClient={keycloak}
      initOptions={keycloakProviderInitConfig}
    >
      <App />
    </ReactKeycloakProvider>
  </React.StrictMode>
);

reportWebVitals();